import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b6cf0c1e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=b6cf0c1e&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cf0c1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6cf0c1e')) {
      api.createRecord('b6cf0c1e', component.options)
    } else {
      api.reload('b6cf0c1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b6cf0c1e&scoped=true", function () {
      api.rerender('b6cf0c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/Checkbox/index.vue"
export default component.exports